import noSearchFound from "../../../assets/no-search-found.svg";
export const headerData = [{ text: "" }, { text: "ID" }, { text: "Title" }];

export const footerData = {
  title: "No record found",
  subTtitle: "No such category exists. Create one?",
  imgSrc: noSearchFound,
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "categoryImage",
    type: "img",
    prepend: "",
  },
  {
    key: "categoryHandle",
    type: "",
    prepend: "",
  },
  {
    key: "categoryTitle",
    type: "",
    prepend: "",
  },
];

export const categoryFlags: any = {
  DEFAULT: {
    buttonText: "Default",
  },
  NEW: {
    buttonText: "New",
  },
  PROMOTED: {
    buttonText: "Promoted",
  },
};
